module.exports = __webpack_public_path__ + "media/images/clients/user_green-6b76164dd860a94d4531c7a3899e829f.png";